module.exports = __webpack_public_path__ + "img/et.2b90d44c.svg";